import React, { useState, useEffect, useRef } from 'react'
import { Table } from "antd";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Cookies from "js-cookie";
// import EditQuoteForm from './modal/EditQuoteForm';
import { useDispatch, useSelector } from 'react-redux';
import Beatloader from '../../../Common/Loaders/Beatloader';
import { useFormik } from 'formik';
import ReactPaginate from 'react-paginate';
import DatePicker from "react-datepicker";
import { capitalizeFirstLetter } from '../../../HelperFunctions';
import { adminMainUrl } from '../../../Config';
import { getUnpickedJobOrderWithExpenseList } from '../../../Redux/action/Account/AccountAction';
import axios from 'axios';
import OverlayLoader from '../../../Common/Loaders/OverlayLoader';


const UnpickedJobOrderList = ({ showTabs, headingText, accessedModules, accessedPermission, impexp, airsea, identifier }) => {

    const location = useLocation();
    const token = Cookies.get("token");
    let user_id = Cookies.get('flexichain_user_id');
    const navigate = useNavigate();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [id, setId] = useState(null)
    const [isResetting, setIsResetting] = useState(false);
    const fromDate = startDate ? formatDate(startDate) : null;
    const toDate = endDate ? formatDate(endDate) : null;


    function formatDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so we add 1
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    useEffect(() => {
        if (isResetting) {
            // fetchQuotations();
            setIsResetting(false);  // Reset the flag after fetching quotations
        }
    }, [isResetting]);

    const resetFields = () => {
        setStartDate(null);
        setEndDate(null);
        setIsResetting(true);
    };


    const columns = [
        { title: "#", dataIndex: "sno", key: "sno" },
        { title: "Job Order No.", dataIndex: "job_order_no", key: "job_order_no" },
        { title: "Has Quotation", dataIndex: "has_quotation", key: "has_quotation" },
        { title: "Quotation No.", dataIndex: "quotation_no", key: "quotation_no" },
        { title: "Tranport mode", dataIndex: "trans_mode", key: "trans_mode" },
        { title: "Transport type", dataIndex: "trans_type", key: "trans_type" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];


    const dispatch = useDispatch();
    const [query, setQuery] = useState("");
    const [pageLoader, setPageLoader] = useState(false);
    const [dataSourcer, setDataSourcer] = useState(false);
    const [currentPage, setCurrentPage] = useState(() => {
        const params = new URLSearchParams(location.search); // Use URLSearchParams
        const savedPage = params.get("page");
        return savedPage ? Number(savedPage) : 1;
    });
    const [totalPages, setTotalPages] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const [paginationPage, setPaginationPage] = useState(0);
    const queryParams = new URLSearchParams(location.search);
    const queryString = new URLSearchParams(location.search).toString();

    useEffect(() => {
        setQuery(queryString);
        if (queryParams.get("page")) {
            setPaginationPage(Number(queryParams.get("page") - 1))
        } else {
            setPaginationPage(0);
        }
    }, [queryParams]);


    useEffect(() => {
        if (user_id && token) {
            dispatch(getUnpickedJobOrderWithExpenseList(token, user_id, queryParams.get("page") ?? 1, identifier, impexp, airsea, queryString));
        }
    }, [query, user_id, location]);

    let {
        loadingUnpickedJobOrderWithExpenseList,
        UnpickedJobOrderWithExpenseListError,
        UnpickedJobOrderWithExpenseList,
        UnpickedJobOrderWithExpenseListCurrentPage,
        UnpickedJobOrderWithExpenseListTotalPage,
        UnpickedJobOrderWithExpenseListTotalData,
        UnpickedJobOrderWithExpenseListNewJobOrderCount,
        UnpickedJobOrderWithExpenseListPickedJobOrderCount
    } = useSelector(state => state?.AccountReducer);



    const refreshData = () => {
        if (user_id && token) {
            dispatch(getUnpickedJobOrderWithExpenseList(token, user_id, queryParams.get("page") ?? 1, identifier, impexp, airsea, queryString));
        }
    }


    const pickJobOrder = (job_order_id) => {
        try {
            if (!job_order_id) {
                toast.error("Please select a job order");
                return;
            }
            setPageLoader(true);
            let config = {
                headers: {
                    "user_id": user_id,
                    "auth-token": token
                }
            }
            let body = {
                "job_order_id": job_order_id
            }
            axios.post(`${adminMainUrl}/api/account/pick-job-order`, body, config)
                .then(response => {
                    if (response.status == 200) {
                        toast.success(response.data.msg);
                        setPageLoader(false);
                        navigate(`/flexichain/account/air/export/picked-joborder/view/${btoa(job_order_id)}`);
                    } else {
                        toast.error(response.data.msg);
                        setPageLoader(false);
                    }
                }).catch(error => {
                    console.log(error);
                    let msg = "Internal server error";
                    if (error && error.response && error.response.data && error.response.data.msg) {
                        msg = error.response.data.msg;
                    };
                    toast.error(msg);
                    setPageLoader(false);
                });
        } catch (error) {
            let msg = "Internal server error";
            if (error && error.message) {
                msg = error.message;
            };
            toast.error(msg);
            setPageLoader(false);
        }
    }


    useEffect(() => {
        // console.log("UnpickedJobOrderWithExpenseListPickedUser", UnpickedJobOrderWithExpenseListPickedUser)
        if (loadingUnpickedJobOrderWithExpenseList) {
            setPageLoader(true);
        } else {
            setPageLoader(false);
        };

        if (UnpickedJobOrderWithExpenseList) {
            let arr = UnpickedJobOrderWithExpenseList?.map((value, i) => ({
                key: i + 1,
                sno: Number(paginationPage) * 10 + (i + 1),
                job_order_no: <>{value?.job_order_unique_no} {value.is_locked ? <i className="fa-solid fa-lock ms-2" title="This operation is locked." style={{ color: "#ff0000" }}></i> : null}</>,
                has_quotation: value?.has_quotation ? "YES" : "NO",
                quotation_no: value.has_quotation ? value?.quotation_number ?? "-" : "-",
                trans_mode: value?.trans_mode,
                trans_type: value?.trans_type,
                action: (
                    <>
                        <div className="d-flex">
                            <div className="dropdown table-action">
                                <Link to="#" className="action-icon" data-bs-toggle="dropdown" >
                                    <i className="fa fa-ellipsis-v"></i>
                                </Link>
                                {
                                    (

                                        identifier == "unpicked-joborder" && airsea == "air" && impexp == "import" && accessedPermission.includes("account_ai_pick_job_order") ||
                                        identifier == "unpicked-joborder" && airsea == "air" && impexp == "export" && accessedPermission.includes("account_ae_pick_job_order") ||
                                        identifier == "unpicked-joborder" && airsea == "sea" && impexp == "import" && accessedPermission.includes("account_si_pick_job_order") ||
                                        identifier == "unpicked-joborder" && airsea == "sea" && impexp == "export" && accessedPermission.includes("account_se_pick_job_order") ||
                                        identifier == "picked-joborder" && airsea == "air" && impexp == "import" && accessedPermission.includes("account_ai_view_job_order") ||
                                        identifier == "picked-joborder" && airsea == "air" && impexp == "export" && accessedPermission.includes("account_ae_view_job_order") ||
                                        identifier == "picked-joborder" && airsea == "sea" && impexp == "import" && accessedPermission.includes("account_si_view_job_order") ||
                                        identifier == "picked-joborder" && airsea == "sea" && impexp == "export" && accessedPermission.includes("account_se_view_job_order")

                                    ) &&
                                    <div className="dropdown-menu dropdown-menu-right">
                                        <div className="dropdown-item" onClick={() => {
                                            if (identifier == "unpicked-joborder") {
                                                pickJobOrder(value.id); // Hit the API only if filterTab is "all"
                                            } else if (identifier == "picked-joborder") {
                                                navigate(`/flexichain/account/air/export/picked-joborder/view/${btoa(value.id)}`)
                                            }
                                        }}>
                                            <i className="ti ti-eye text-blue-light"></i> Preview
                                        </div>
                                        {value.is_locked ? <div className="dropdown-item" onClick={() => { downloadBill(value.id, value.job_order_unique_no) }}>
                                            <i className="fa-solid fa-download me-2 text-blue-light"></i> Download Bill
                                        </div> : null}
                                    </div>}
                            </div>
                        </div>

                    </>
                ),
            }));
            setDataSourcer(arr);
        }

        if (UnpickedJobOrderWithExpenseListTotalData) {
            setTotalItems(UnpickedJobOrderWithExpenseListTotalData);
        }

        if (UnpickedJobOrderWithExpenseListTotalPage) {
            setTotalPages(UnpickedJobOrderWithExpenseListTotalPage)
        }
    }, [loadingUnpickedJobOrderWithExpenseList, UnpickedJobOrderWithExpenseListError, UnpickedJobOrderWithExpenseList, UnpickedJobOrderWithExpenseListCurrentPage, UnpickedJobOrderWithExpenseListTotalPage, UnpickedJobOrderWithExpenseListTotalData]);
    //pagination
    const handlePageClick = (selectedObject) => {
        const selectedPage = selectedObject.selected + 1;
        const params = new URLSearchParams(location.search);
        setCurrentPage(selectedPage);
        params.set("page", selectedPage);
        navigate(`?${params.toString()}`);
    };

    //search and filter data
    const parseQueryParams = () => {
        const params = new URLSearchParams(location.search);
        return {
            search_by: params.get("search_by") || "",
            request_no: params.get("request_no") || "",
            name: params.get("name") || "",
            email: params.get("email") || "",
            phone: params.get("phone") || "",
            origin: params.get("origin") || "",
            destination: params.get("destination") || "",
            shipment_type_id: params.get("shipment_type_id") || "",
            shipment_via_id: params.get("shipment_via_id") || "",
            required_servie_id: params.get("required_servie_id") || "",
            start_date: params.get("start_date") || "",
            end_date: params.get("end_date") || "",
            quotation_date: params.get("quotation_date") || "",
            filter_by: params.get("filter_by") || ""
        };
    };

    let formik = useFormik({
        initialValues: parseQueryParams(),
        onSubmit: (values) => {
            const params = new URLSearchParams(location.search);
            Object.keys(values).forEach((key) => {
                if (values[key]) {
                    params.set(key, values[key]);
                } else {
                    params.delete(key);
                }
            });

            if (!params.has("page")) {
                params.set("page", "1");
            } else {
                params.set("page", "1");
            }
            const queryString = params.toString();
            navigate(`${location.pathname}?${queryString}`);
            const currentPage = 1;
            const ITEMS_PER_PAGE = 10;
            dispatch(getUnpickedJobOrderWithExpenseList(token, user_id, queryParams.get("page") ?? 1, identifier, impexp, airsea, queryString));
        },
    });

    const resetFilters = () => {
        try {
            formik.setValues({
                search_by: "",
                request_no: "",
                name: "",
                email: "",
                phone: "",
                origin: "",
                destination: "",
                shipment_type_id: "",
                shipment_via_id: "",
                required_servie_id: "",
                start_date: "",
                end_date: "",
                quotation_date: "",
                filter_by: "",
            });
            // navigate(`/flexichain/picked-rate-request-list?page=1`);
            let url = `/flexichain/account/${airsea}/${impexp}/unpicked-joborder`;
            // if (identifiter === "all") { url = "/flexichain/all-query-list" }
            // else if (identifiter === "picked") { url = "/flexichain/picked-query-list" }
            // else if (identifiter === "send-for-pricing") { url = "/flexichain/send-for-pricing-query-list" }
            // else if (identifiter === "price-received") { url = "/flexichain/price-received-query-list" }
            // else if (identifiter === "price-viewed") { url = "/flexichain/price-viewed-query-list" }
            // else if (identifiter === "repricing") { url = "/flexichain/repricing-query-list" }
            // else if (identifiter === "quotation-sent") { url = "/flexichain/quotation-sent-query-list" }
            // else if (identifiter === "converted") { url = "/flexichain/converted-query-list" }
            // else if (identifiter === "not-converted") { url = "/flexichain/not-converted-query-list" }
            if (url) {
                navigate(url);
            }
        } catch (error) {
            console.log(error.message);
            toast.error("Some error occured!");
        }
    };

    const handleStartDateChange = (date) => {
        if (date && date.getTime() === endDate?.getTime()) {
            alert("Start date and end date cannot be the same");
            return;
        }
        setStartDate(date);
        if (endDate && date && endDate.getTime() < date.getTime()) {
            setEndDate(null);
        }
    };
    const handleEndDateChange = (date) => {
        if (date && date.getTime() === startDate?.getTime()) {
            Swal.fire('Error', 'Start date and end date cannot be the same', 'error');
            return;
        }
        if (date && startDate && date.getTime() < startDate.getTime()) {
            Swal.fire('Error', 'End date cannot be before the start date', 'error');
            return;
        }
        setEndDate(date);
    };




    const [disableDownloadPDF, setDisableDownloadPDF] = useState(false);
    const downloadBill = (id, job_order_no) => {
        if (!id) { toast.error("HAWB not found"); return; }
        setDisableDownloadPDF(true);
        let config = { headers: { 'auth-token': token, user_id: user_id }, responseType: 'blob', };
        try {
            axios.get(`${adminMainUrl}/api/account/download-bill?job_order_id=${id}`, config)
                .then(response => {
                    if (response.status == 200) {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `AccountBill_${job_order_no}.pdf`);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setDisableDownloadPDF(false);
                    } else {
                        toast.error(response.error.message);
                        setDisableDownloadPDF(false);
                    }
                }).catch(error => {
                    console.log(error);
                    // let err_msg = error.message;
                    toast.error(error.message);
                    setDisableDownloadPDF(false);
                })
        } catch (error) {
            console.log(error);
            toast.error(error.message);
            setDisableDownloadPDF(false);
        }
    }
    return (
        <>
            {
                pageLoader ?
                    <Beatloader />
                    :
                    <div className="page-wrapper">
                        <div className="content">
                            <div className="row">
                                <div className="col-md-12">
                                    {/* Page Header */}
                                    <div className="page-header">
                                        <div className="row align-items-center">
                                            <div className="col-8">
                                                <h4 className="page-title">
                                                    {headingText} <span className="count-title">{UnpickedJobOrderWithExpenseListTotalData ? UnpickedJobOrderWithExpenseListTotalData : 0}</span>
                                                </h4>
                                            </div>
                                            <div className="col-4 text-end">
                                                <div className="head-icons">
                                                    <a
                                                        href="javascript:void(0);"
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        data-bs-original-title="Collapse"
                                                        id="collapse-header"
                                                    >
                                                        <i className="ti ti-chevrons-up" />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* /Page Header */}
                                </div>
                            </div>


                            <form onSubmit={formik.handleSubmit}>
                                <div className="card">
                                    <div className="card-header py-2">
                                        {/* Search */}
                                        <div className="row align-items-center">
                                            <div className="col-sm-4">
                                                <div className="icon-form mb-3 mb-sm-0">
                                                    <span className="form-icon">
                                                        <i className="ti ti-search" />
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        placeholder="Search"
                                                        name='search_by'
                                                        value={formik.values.search_by}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    // value={searchText}
                                                    // onChange={(e) => setSearchText(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-8">

                                                <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                                                    <button type='submit' className="btn btn-primary me-2">
                                                        Search
                                                    </button>
                                                    <a
                                                        className='btn btn-primary me-2'
                                                        //   style={{ background: "#04aed2", marginTop: "7px", marginBottom: "15px" }}
                                                        onClick={() => { resetFilters() }}
                                                    >
                                                        Clear
                                                    </a>

                                                    {/* {accessedPermission.includes("add_quote_request_form") && <Link
                                                        to="/flexichain/quote-form"
                                                        className="btn btn-primary"
                                                    // data-bs-toggle="offcanvas"
                                                    // data-bs-target="#offcanvas_create"
                                                    >
                                                        <i className="ti ti-square-rounded-plus me-2" />
                                                        Create Quote
                                                    </Link>} */}
                                                </div>
                                            </div>
                                        </div>
                                        {/* /Search */}
                                    </div>
                                    <div className="card-body py-2">

                                        {/* Contact List */}

                                        {showTabs && <div className='' style={{ width: "auto", overflowX: "auto", overflowY: "hidden", scrollBehavior: "smooth" }}>
                                            <ul className="nav mx-1 nav-pills nav-slider my-2 border-2 custom-tabs" id="pills-tab" role="tablist">
                                                {(
                                                    airsea == "air" && impexp == "import" && accessedPermission.includes("account_ai_unpicked_job_order") ||
                                                    airsea == "air" && impexp == "export" && accessedPermission.includes("account_ae_unpicked_job_order") ||
                                                    airsea == "sea" && impexp == "import" && accessedPermission.includes("account_si_unpicked_job_order") ||
                                                    airsea == "sea" && impexp == "export" && accessedPermission.includes("account_se_unpicked_job_order")
                                                ) && <li className="nav-item" role="presentation">
                                                        <button onClick={() => { resetFilters(); navigate(`/flexichain/account/${airsea}/${impexp}/unpicked-joborder`) }} className={`nav-link fw-semibold custom-tab  ${identifier == "unpicked-joborder" && 'active'} position-relative`} id="all-list-tab" data-bs-toggle="pill" data-bs-target="#all-list" type="button" role="tab" aria-controls="all-list" aria-selected="true">New <span className="tab-count">{UnpickedJobOrderWithExpenseListNewJobOrderCount ?? 0}</span></button>
                                                    </li>
                                                }
                                                {(
                                                    airsea == "air" && impexp == "import" && accessedPermission.includes("account_ai_picked_job_order") ||
                                                    airsea == "air" && impexp == "export" && accessedPermission.includes("account_ae_picked_job_order") ||
                                                    airsea == "sea" && impexp == "import" && accessedPermission.includes("account_si_picked_job_order") ||
                                                    airsea == "sea" && impexp == "export" && accessedPermission.includes("account_se_picked_job_order")
                                                ) && <li className="nav-item" role="presentation">
                                                        <button onClick={() => { resetFilters(); navigate(`/flexichain/account/${airsea}/${impexp}/picked-joborder`) }} className={`nav-link ${identifier == "picked-joborder" && 'active'} fw-semibold custom-tab  position-relative`} id="all-list-tab" data-bs-toggle="pill" data-bs-target="#all-list" type="button" role="tab" aria-controls="all-list" aria-selected="true">Picked<span className="tab-count">{UnpickedJobOrderWithExpenseListPickedJobOrderCount ?? 0}</span></button>
                                                    </li>}
                                            </ul>
                                        </div>}


                                        <div className="table-responsive custom-table query-list-table">
                                            <Table className="table datanew dataTable no-footer"
                                                // rowSelection={rowSelection} 
                                                dataSource={dataSourcer}
                                                columns={columns}
                                                pagination={false}
                                                rowClassName={(record) => (record.is_priority === "YES" ? "prior-query" : "")}
                                            />
                                        </div>

                                        <div className="row align-items-center">
                                            {UnpickedJobOrderWithExpenseList?.length > 0 && <div className="pagination-controls my-5 d-flex justify-content-center align-items-center react-custom-paginate">
                                                <ReactPaginate
                                                    previousLabel={<img src="/img/right.png" alt="Previous" />}
                                                    nextLabel={<img src="/img/left.png" alt="Next" />}
                                                    breakLabel="..."
                                                    breakClassName="break-me"
                                                    pageCount={totalPages}
                                                    marginPagesDisplayed={2}
                                                    pageRangeDisplayed={5}
                                                    onPageChange={handlePageClick}
                                                    containerClassName="pagination"
                                                    activeClassName="active"
                                                    forcePage={currentPage - 1}
                                                />
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </form>

                        </div >
                    </div >
            }
            {
                disableDownloadPDF && <OverlayLoader />
            }

        </>

    )
}

export default UnpickedJobOrderList